export class RestoreScreenEvents {
	public static readonly RESTORE_WINDOW_CLOSED: string = 'RestoreScreenEvents::RESTORE_WINDOW_CLOSED';
	public static readonly RESTORE_WINDOW_OPENED: string = 'RestoreScreenEvents::RESTORE_WINDOW_OPENED';
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/restoreScreen/RestoreScreenEvents.ts